<template>
  <div>
    <div class="tab-flex">
      <div class="tabs">
        <div class="tab-item" :class="index === 0 ? 'active' : ''" @click="tapFn(0)">
          <!-- <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon7.png" alt=""> -->
          SPBCN冠军冬训营
        </div>
        <div class="tab-item" :class="index === 1 ? 'active' : ''" @click="tapFn(1)">
          <!-- <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png" alt=""> -->
          赛事训练营
        </div>
        <!-- <div class="tab-add-btn" @click="handleAdd">
          <i class="el-icon-plus"></i> 添加产品
        </div> -->
      </div>
      <el-button type="text" style="color: rgb(31, 48, 199);" @click="nextPage">查看全部营地>></el-button>
    </div>

    <!-- 添加赛事产品抽屉 -->
    <el-drawer
      title="添加赛事产品"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="500px"
    >
      <div class="drawer-content">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
          <el-form-item label="产品名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入产品名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品Logo" prop="logo">
            <el-upload
              accept="image/jpeg,image/gif,image/png,image/jpg"
              class="logo-uploader"
              ref="uploadLogoRef"
              action="void"
              :http-request="customUpload"
              :before-upload="beforeLogoUpload"
              :show-file-list="false"
              :auto-upload="true"
            >
              <el-image
                v-if="form.logo"
                class="logo-image"
                :src="form.logo"
                fit="cover"
                @click.stop
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div v-else class="upload-placeholder">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="upload-text">点击上传Logo</div>
              </div>
              <!-- 删除按钮 -->
              <div v-if="form.logo" class="upload-actions" @click.stop>
                <el-button
                  type="text"
                  size="mini"
                  @click="removeLogo"
                  style="color: #f56c6c;"
                >
                  <i class="el-icon-delete"></i>
                </el-button>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>

        <div class="drawer-footer">
          <el-button @click="drawerVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave" icon="el-icon-check">保 存</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'EmptyComponent',
  props: {
    index: {
      type: Number
    }
  },
  data () {
    return {
      drawerVisible: false,
      form: {
        name: '',
        logo: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        logo: [
          { required: true, message: '请上传产品Logo', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    tapFn (index) {
      this.$emit('tap', index)
    },
    handleAdd () {
      this.form = { name: '', logo: '' }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
      this.drawerVisible = true
    },
    // 自定义上传方法
    customUpload (params) {
      this.$upLoadFileRequest.uploadFileResults(
        params,
        {
          upLoadType: 'logo',
          uploadUrl: this.$env.baseIP + 'upload/uploadFileAliOss'
        }
      ).then(res => {
        if (res && res.data && res.data.data) {
          this.form.logo = res.data.data
          this.$message.success('Logo上传成功!')
        } else {
          this.$message.error('上传失败，请重试!')
        }
      }).catch(() => {
        this.$message.error('上传失败，请重试!')
      })
    },
    // Logo上传前校验
    beforeLogoUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return false
      }
      return true
    },
    // 删除Logo
    removeLogo () {
      this.$confirm('确认删除Logo吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.logo = ''
        this.$message.success('删除成功!')
      }).catch(() => {})
    },
    // 保存
    handleSave () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        console.log('保存数据:', this.form)
        this.$message.success('保存成功!')
        this.drawerVisible = false
      })
    },
    nextPage () {
      this.$router.push('/raceManagement/camp/campListData')
    }
  }
}
</script>

<style lang="less" scoped>
.drawer-content {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  padding: 20px;
  box-sizing: border-box;
}
.drawer-footer {
  margin-top: auto;
  padding-top: 20px;
  text-align: center;
  padding-bottom: 20px;
}
.logo-uploader {
  display: inline-block;
  cursor: pointer;
  position: relative;
  .logo-image {
    width: 120px;
    height: 120px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    display: block;
  }
  .upload-placeholder {
    width: 120px;
    height: 120px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #8c939d;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    margin-bottom: 4px;
  }
  .upload-text {
    font-size: 12px;
    color: #8c939d;
  }
  .upload-actions {
    position: absolute;
    bottom: -6px;
    right: -6px;
  }
}
.tab-add-btn{
  width: 120px;
  height: 36px;
  background-color: #fcedb6;
  color: #000;
  border-radius: 14px 14px 0 0;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover{
    background-color: #fbe491;
  }
}
::v-deep .el-drawer__header {
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}
.tab-flex{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tabs{
  display: flex;
  align-items: flex-end;
  .tab-item{
    width: 200px;
    height: 36px;
    border-radius: 14px 14px 0 0;
    color: #000;
    background-color: #fff;
    font-size: 14px;
    margin-right: 2px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo{
    width: 28px;
    height: 28px;
    margin-right: 4px;
    object-fit: contain;
    display: none;
  }
  .active{
    background-color: #FAD54A;
    height: 44px;
    font-weight: bold;
    font-size: 16px;
    .logo{
      display: block;
    }
  }
}
</style>
